import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [
		'input',
		'hideElement',
	]

	static values = {
		valuesArray: Array,
		targetSelector: String,
		invertLogic: { type: Boolean, default: false },
	}

	connect() {
		if (this.hasHideElementTarget) {
			this.elementsToHide = this.hideElementTargets
		} else if (this.hasTargetSelectorValue) {
			this.elementsToHide = document.querySelectorAll(this.targetSelectorValue)
		} else {
			console.error('Error: there are no elements to hide in HideIfController.')
		}

		this.updateElements()
	}	

	updateElements() {
		if (!this.hasInputTarget) return undefined

		if (this.valuesArrayValue.some(value => value == this.getInputValue())) {
			this.hideElements()
		} else {
			this.showElements()
		}
	}

	getInputValue() {
		if (this.inputTargets.length >= 1) {
			if (['radio', 'checkbox'].some(type => type == this.inputTargets[0].type)) {
				const checkedInput = this.inputTargets.find(input => input.checked)
				if (checkedInput) {
					return checkedInput.value
				} else {
					return undefined
				}
			} else {
				console.error("Error: multiple inputs present that aren't radio or checkbox inputs")
				return null
			}
		}

		if (['radio', 'checkbox'].some(type => type == this.inputTarget.type)) {
			if (!this.inputTarget.checked) return '0'
		}

		return this.inputTarget.value
	}

	inputChanged(_event) {
		this.updateElements()
	}

	hideElements() {
		if(this.invertLogicValue) {
			this.elementsToHide.forEach( element => element.classList.remove('d-none') )
		} else {
			this.elementsToHide.forEach( element => element.classList.add('d-none') )
		}
	}

	showElements() {
		if(this.invertLogicValue) {
			this.elementsToHide.forEach( element => element.classList.add('d-none') )
		} else {
			this.elementsToHide.forEach( element => element.classList.remove('d-none') )
		}
	}

}
